import { render, staticRenderFns } from "./BankModal.vue?vue&type=template&id=1ecad3d4&scoped=true&"
import script from "./BankModal.vue?vue&type=script&lang=ts&"
export * from "./BankModal.vue?vue&type=script&lang=ts&"
import style0 from "./BankModal.vue?vue&type=style&index=0&id=1ecad3d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecad3d4",
  null
  
)

export default component.exports